import React, { Component } from 'react';
import FoundationLayout from '../components/layout/FoundationLayout';
import ComingSoon from '../components/layout/ComingSoon';

/**
 * IITFoundationPractice — IIT Foundation portal page.
 *
 * Placeholder for now: rendered inside the portal's own FoundationLayout (its own
 * sidebar/header), with no rizee student navbar, no studenttoken gate, and no
 * cookies / localStorage. Real data will be wired once the portal has its own
 * session/data layer.
 */
class IITFoundationPractice extends Component {
    render() {
        return (
            <FoundationLayout>
                <ComingSoon title="Practice" />
            </FoundationLayout>
        );
    }
}

export default IITFoundationPractice;
